import { render, staticRenderFns } from "./manage-class.vue?vue&type=template&id=23bbd0ef&scoped=true&"
import script from "./manage-class.vue?vue&type=script&lang=js&"
export * from "./manage-class.vue?vue&type=script&lang=js&"
import style0 from "./manage-class.vue?vue&type=style&index=0&id=23bbd0ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbd0ef",
  null
  
)

export default component.exports